import { render, staticRenderFns } from "./CashierDisplay.vue?vue&type=template&id=a6d7c2f6&scoped=true"
import script from "./CashierDisplay.vue?vue&type=script&lang=ts"
export * from "./CashierDisplay.vue?vue&type=script&lang=ts"
import style0 from "./CashierDisplay.vue?vue&type=style&index=0&id=a6d7c2f6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d7c2f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6d7c2f6')) {
      api.createRecord('a6d7c2f6', component.options)
    } else {
      api.reload('a6d7c2f6', component.options)
    }
    module.hot.accept("./CashierDisplay.vue?vue&type=template&id=a6d7c2f6&scoped=true", function () {
      api.rerender('a6d7c2f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cashier/CashierDisplay.vue"
export default component.exports